<template>
  <div>
    <top-header></top-header>
    <site-header></site-header>
    <inner-banner title="About Us" current-page="About Us"></inner-banner>

    <!-- about section -->
    <section class="video-section py-5">
      <div class="container py-md-5 py-4">
        <div class="row">
          <div class="col-lg-6 about-right-faq align-self pr-lg-5">
            <h3 class="title-big">Our Mission is to Provide a World‑class Education</h3>
            <p class="mt-3">An immersing environment for expats to learn Chinese language well whilst developing a
              better understanding of the people and place, where they live and work. </p>
          </div>
          <div class="col-lg-6 left-wthree-img-video text-righ pr-lg-5 mt-lg-0 mt-5">
            <MyWistiaPlayer media-id="x21owe5ym3" />
          </div>
        </div>
      </div>
    </section>
    <!-- //about section -->

    <!-- stats -->
    <section class="w3_stats pb-5" id="stats">
      <div class="container pb-md-5 pb-4 pt-4">
        <div class="w3-stats">
          <div class="row text-center">
            <div class="col-lg-3 col-sm-6">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.COUNTRIES" data-speed="1500"></div>
                <p class="count-text">COUNTRIES</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-sm-0 mt-4">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.SUCCESSFUL_STUDENTS" data-speed="1500"></div>
                <p class="count-text">SUCCESSFUL STUDENTS</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-lg-0 mt-4">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.TOTAL_COURSES" data-speed="1500"></div>
                <p class="count-text">TOTAL COURSES</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-lg-0 mt-4">
              <div class="counter border-right-0">
                <div class="timer count-title count-number" :data-to="strengthNumbers.YEARLY_TEACHING_HOURS" data-speed="1500"></div>
                <p class="count-text">YEARLY TEACHING HOURS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //stats -->

    <!-- about-bootom grids -->
    <section class="w3l-bottom-about py-5">
      <div class="container py-md-5 py-4">
        <div class="grids-area-hny main-cont-wthree-fea row">
          <div class="col-lg-4 col-md-6 grids-feature">
            <div class="area-box">
              <span class="fa fa-smile-o" aria-hidden="true"></span>
              <h4>
                <router-link to="#feature" class="title-head">Class Forms</router-link>
              </h4>
              <p class="mb-3">Group class and Private class are provided, which both are available for online and
                offline(Chengdu/Chongqing, China)</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 grids-feature mt-md-0 mt-4">
            <div class="area-box">
              <span class="fa fa-graduation-cap icon-style-2" aria-hidden="true"></span>
              <h4>
                <router-link to="#feature" class="title-head">Trending Courses</router-link>
              </h4>
              <p class="mb-3">15 courses for people who have different needs and levels of learning, such as
                Comprehensive, HSK, Speaking or Reading.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 grids-feature mt-lg-0 mt-4">
            <div class="area-box">
              <span class="fa fa-users icon-style-3" aria-hidden="true"></span>
              <h4>
                <router-link to="#feature" class="title-head">Expert Teachers</router-link>
              </h4>
              <p class="mb-3">The average teaching experience of our teachers,with cross-cultural communica-tion and
                bilingual skills, has reached over 1825 hours a year.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //bottom-grids-->

    <!-- team section -->
    <section class="w3l-team py-sm-5 pb-sm-0 pb-5">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">Who Makes the Magic Happen? <span>Know About Them</span></h3>
        </div>
        <div class="row text-center">
          <div v-for="teacher in teachers" :key="teacher.id" class="col-lg-3 col-sm-6 mt-lg-0 mt-5">
            <div class="team-block-single">
              <div class="team-grids">
                <router-link :to="`/teacher/${teacher.id}`">
                  <img :src="teacher.teacher_image" class="img-fluid" alt="" />
                  <div class="team-info"></div>
                </router-link>
              </div>
              <div class="team-bottom-block p-4">
                <h5 class="member mb-1">
                  <router-link :to="`/teacher/${teacher.id}`">{{ teacher.teacher_name }}</router-link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //team setion -->

    <!-- about section -->
    <section class="w3l-about-3 pb-5 pt-2">
      <div class="container py-md-5 py-4 mb-5">
        <div class="row align-items-center justify-content-between">
          <div class="col-lg-6 pr-lg-5">
            <h3 class="title-big">Join Us to Master Your Chinese</h3>
            <p class="mt-3">We provide not only Chinese courses, but also cultural events.</p>
            <ul class="list-about-2 mt-sm-4 mt-3">
              <li class="py-1"><i class="fa fa-check-square-o mr-2" aria-hidden="true"></i>Hands-on Experience</li>
              <li class="py-2"><i class="fa fa-check-square-o mr-2" aria-hidden="true"></i>Chinese Environment</li>
              <li class="py-1"><i class="fa fa-check-square-o mr-2" aria-hidden="true"></i>Cultural Background</li>
            </ul>
          </div>
          <div class="col-lg-6 about-2-secs-right mt-lg-0 mt-5">
            <img src="@/assets/images/about1.jpg" alt="" class="img-fluid img-responsive"/>
          </div>
        </div>
      </div>
    </section>
    <!-- //about section -->

    <footer-component></footer-component>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import FooterComponent from '@/components/Footer.vue'
import InnerBanner from '@/components/InnerBanner.vue'
import MyWistiaPlayer from '@/components/MyWistiaPlayer.vue'
import { getConfig } from '@/api/config'
import { getTeacherList } from '@/api/teacher'
export default {
  name: 'AboutPage',
  components: {
    TopHeader,
    SiteHeader,
    FooterComponent,
    InnerBanner,
    MyWistiaPlayer
  },
  data() {
    return {
      strengthNumbers: {
        COUNTRIES: '0',
        SUCCESSFUL_STUDENTS: '0',
        TOTAL_COURSES: '0',
        YEARLY_TEACHING_HOURS: '0'
      },
      teachers: []
    }
  },
  async created() {
    await this.fetchStrengthNumbers()
    await this.fetchTeachers()
  },
  mounted() {
    this.initCounter();
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
    this.loadWistiaPlayer();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async fetchStrengthNumbers() {
      try {
        const res = await getConfig('STRENGTH_NUMBERS')
        if (Array.isArray(res)) {
          res.forEach(item => {
            if (item.key && item.value) {
              this.strengthNumbers[item.key] = item.value
            }
          })
          this.$nextTick(() => {
            this.initCounter()
          })
        }
      } catch (error) {
        console.error('Failed to fetch statistics:', error)
      }
    },
    async fetchTeachers() {
      try {
        const res = await getTeacherList()
        this.teachers = Array.isArray(res) ? res : []
      } catch (e) {
        this.teachers = []
      }
    },
    loadWistiaPlayer() {
      // 检查是否已经加载了 Wistia 脚本
      if (!document.querySelector('script[src*="wistia.com/player.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://fast.wistia.com/player.js';
        script.async = true;
        script.onload = () => {
          // 脚本加载完成后初始化播放器
          if (window.Wistia) {
            window.Wistia.api('x21owe5ym3');
          }
        };
        document.body.appendChild(script);
      }
    },
    initCounter() {
      const counters = document.querySelectorAll('.count-number');
      const speed = 200;

      const animateCounter = (counter) => {
        const target = +counter.getAttribute('data-to');
        const count = +counter.innerText;
        const inc = target / speed;

        if (count < target) {
          counter.innerText = Math.ceil(count + inc);
          setTimeout(() => animateCounter(counter), 1);
        } else {
          counter.innerText = target;
        }
      };

      const startCounting = () => {
        counters.forEach(counter => {
          counter.innerText = '0';
          animateCounter(counter);
        });
      };

      // 当元素进入视口时开始计数
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startCounting();
            observer.unobserve(entry.target);
          }
        });
      });

      document.querySelector('.w3-stats').querySelectorAll('.counter').forEach(counter => {
        observer.observe(counter);
      });
    },
    handleScroll() {
      const header = document.getElementById('site-header');
      if (header) {
        if (window.scrollY >= 80) {
          header.classList.add('nav-fixed');
        } else {
          header.classList.remove('nav-fixed');
        }
      }
    }
  }
}
</script>

<style scoped>
.popup-with-zoom-anim {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
}

.video-play-icon {
    display: inline-block;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 50%;
    transition: all 0.3s ease;
}

.video-play-icon:hover {
    background: var(--secondary-color);
}

.video-play-icon .fa {
    color: #fff;
    font-size: 30px;
}

.wistia_responsive_padding {
    position: relative;
    background: #000;
    max-width: 800px;
    margin: 0 auto;
}

.wistia_responsive_wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.wistia_embed {
    position: relative;
    width: 100%;
    height: 100%;
}

.wistia_swatch {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    overflow: hidden;
    transition: opacity 200ms;
}

.wistia_swatch img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: blur(5px);
}
</style> 